module.exports = __webpack_public_path__ + "img/mobile-providers.acb4809b.png";